const IMAGE_CDN =
    'https://d1vyenbk43iobe.cloudfront.net/application/images/auth';

export const authNavigationImages = [
    `${IMAGE_CDN}/registration-email.png`,
    `${IMAGE_CDN}/forgotten-email@2x.png`,
    `${IMAGE_CDN}/forgotten-confirmation.png`,
];

export const logoutImages = [
    `${IMAGE_CDN}/giphy.gif`,
    `${IMAGE_CDN}/giphy2.gif`,
];

export const preloadImages = (sources: string[]): void => {
    sources.forEach((src) => {
        const image = new Image();
        image.src = src;
    });
};
